import { Component, forwardRef, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import {
  ControlValueAccessor,
  FormBuilder,
  FormGroup,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { TreeNode } from '@cdw-ae/common-ui-components-tree';
import { debounceTime, Subject } from 'rxjs';

@Component({
  selector: 'lib-cdw-filtered-tree-picker',
  templateUrl: './cdw-filtered-tree-picker.component.html',
  styleUrls: ['./cdw-filtered-tree-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CdwFilteredTreePickerComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class CdwFilteredTreePickerComponent
  implements OnInit, OnChanges, ControlValueAccessor
{
  @Input() dataSource!: TreeNode[];

  @Input() height = '250px';

  @Input() filterLabel!: string;

  @Input() filterPlaceholder!: string;

  @Input() multiSelect = false;

  @Input() progressiveParentSelect = false;

  @Input() scrollToValue: unknown;

  filterValue = '';

  treeForm!: FormGroup;

  selectedValue!: unknown;

  filteredDataSource!: TreeNode[];

  inputChanged = new Subject<string>();

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.treeForm = this.fb.group({
      treeControl: [''],
    });

    this.filteredDataSource = this.dataSource;

    this.inputChanged.pipe(debounceTime(300)).subscribe((inputValue) => {
      this.filterValue = inputValue;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // biome-ignore lint: TODO: Fix this suggestion: if·(changes['dataSource']?.currentValue)·& literal keys
    if (changes['dataSource'] && changes['dataSource'].currentValue) {
      // biome-ignore lint: TODO: Fix this suggestion literal keys
      this.filteredDataSource = changes['dataSource'].currentValue;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onChange = (value: unknown) => {
    // Placeholder for ControlValueAccessor - will be replaced by registerOnChange
  };

  onTouched = () => {
    // Placeholder for ControlValueAccessor - will be replaced by registerOnTouched
  };

  registerOnChange(fn: () => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = () => fn();
  }

  writeValue(value: unknown) {
    this.treeForm?.get('treeControl')?.setValue(value);
  }

  onInputChange($event?: Event) {
    const inputValue = (
      ($event?.target as HTMLInputElement)?.value || ''
    ).toLowerCase();
    this.inputChanged.next(inputValue);
  }

  getTreeHeight() {
    const regex = /^(\d+)(\D+)$/;
    const match = this.height.match(regex);

    if (!match) {
      throw new Error('Invalid height value');
    }

    const originalValue = parseInt(match[1], 10);
    const unit = match[2];

    const newValue = originalValue - 73;

    return `${newValue}${unit}`;
  }

  onSelectedNodeChanged(value: string | string[]) {
    if (Array.isArray(value)) {
      this.selectedValue = value;
    } else {
      this.selectedValue = value;
    }
    this.onChange(this.selectedValue);
    this.onTouched();
  }
}
